import Api from '@/services/Api'

export default {
    leaEstados(novedad){
        return Api().get('leaEstados/'+novedad)
    },
    leaEstadoTransiciones(estado){
        return Api().get('leaEstadoTransiciones/'+estado)
    },
    grabaEstado(forma){
        return Api().post('grabaEstado',forma)
    },
    actualizaEstado(forma){
        return Api().post('actualizaEstado',forma)
    },
    borraEstado(id){
        return Api().post('borraEstado/'+id)
    },
}
